export default [
  {
    path: "/growth-camp",
    name: "光华赋能 | 方法论+工作法，可复制的结构性增长",
    component: () =>
      import("@/views/blm-scientific-management/big-growth-camp.vue"),
    meta: {
      title: "大增长营"
    }
  },
  {
    path: "/research-institute",
    name:
      "科研院|企业创始人与高管共同学习“用科学经营实现高质量发展”的一个实践社群",
    component: () =>
      import("@/views/blm-scientific-management/research-institute.vue"),
    meta: {
      title: "科研院"
    }
  }
];
